import {Component, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {User} from '../../Interfaces/User';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {Subscription} from 'rxjs';
import {NotificationView} from '../../Interfaces/NotificationView';
import {Router} from '@angular/router';
import {SharedVarService} from '../shared-service.service';
import {AppComponent} from '../../app.component';
import {QueryService} from '../../Services/query.service';
import {SelectionModel} from '@angular/cdk/collections';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  screenMode: string = "C";
  public showQuickView: boolean = true;
  quickViewData: MatTableDataSource<NotificationView>;
  public qvColumns: string[];
  private date1: Date;
  private options4: Intl.DateTimeFormatOptions = {month: "2-digit", day: "2-digit", year: "numeric"};
  classBackground: string= "newField";
  allChecked: boolean = false;
  noneSelected: boolean = true;
  public eventChoice: string;
  public eventChoices: {code: string, description: string }[] = [];
  search1: UntypedFormControl;
  myUser: User;
  txtFromArea: string;
  containerNum: string;
  submitted = false;
  badContainer: boolean = false;
  public didntEnterShit: boolean = false;
  public inSearch: boolean = false;
  public badChars: boolean = false;
  public ipadAppear: boolean = true;
  public ipadApp: boolean = false;
  txtArray2: string [] = [];
  subscription: Subscription;
  private clientRequest: ClientRequest;
  private notification: NotificationView;
  private notificationArray: NotificationView[] = [];
  private notificationContainerArray: NotificationView[] = [];
  private notificationBookingArray: NotificationView[] = [];
  private notificationArrayDisplay: NotificationView[] = [];
  private selection: SelectionModel<NotificationView>;

  @ViewChild(MatSort) set content(sort: MatSort) {
    if (this.quickViewData != undefined) {
      this.quickViewData.sort = sort;
    }
  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.quickViewData != undefined) {
      this.quickViewData.paginator = pag;
    }
  }


  dontShowSearch(){
    if (this.ipadApp){
      this.inSearch = true;
      this.ipadAppear = false;
    }
  }

  returnToSearch(){
    if (this.ipadApp){
      this.inSearch = false;
      this.ipadAppear = true;
    }
  }


  showHideSearch(){
    if (this.ipadApp && !this.inSearch){
      if (this.ipadAppear){
        this.ipadAppear = false;
      }else{
        this.ipadAppear = true;
      }
    }
    this.inSearch = false;

  }


  constructor(fb: UntypedFormBuilder, private router: Router, private service: SharedVarService,private  globalEventsManager: GlobalEventsManager, private myApp: AppComponent, private queryService: QueryService) {
    this.qvColumns = ["check","entity_id","entityDisp","eventDisp","status","created","notified"];


    this.myUser = this.myApp.user;

/*
    this.myUser = {} as User;
    this.myUser.active = "Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = " ";
  //  this.myUser.company_code = "EGN"
    this.myUser.company_code = "M0995"
    this.myUser.company_name = "MAHER TERMINALS, LLC"
    this.myUser.city = "HOUSTON"
    this.myUser.email_address = "miller@maherterminals.com"
    this.myUser.fax_number = null
    this.myUser.first_name = "Csp Craig"
    this.myUser.last_name = "Miller"
    this.myUser.maherError = null
    this.myUser.old_password = null
    this.myUser.password = ""
    this.myUser.phone_number = null
    this.myUser.company_scac = null
    this.myUser.state = "TX"
    this.myUser.userMenuReportItemsView = null
    this.myUser.user_gkey = "8237887"
    this.myUser.role = "AGENT"
   //   this.myUser.role= "LINEOP"
    // this.myUser.role= "HAULIER"
    this.myUser.username = "CSPCRAIG"
    this.myUser.zip = "07201"
    this.myUser.canSeeAllData = "1";


 */

  }
  ngOnInit() {
    if (window.innerWidth > 750 && window.innerWidth <1025){
      this.ipadApp = true;
    }
    this.search1 = new UntypedFormControl();
    this.selection = new SelectionModel<NotificationView>(true);
    this.fillContainerEvents();
    this.queryPending();
  }


  fillContainerEvents(){
    this.eventChoices = null;
    this.eventChoices = [];
    this.eventChoices.push({"code": "F", "description": "Ready For Delivery"});
    this.eventChoices.push({"code": "R", "description": "Received"});
    this.eventChoices.push({"code": "D", "description": "Delivered"});
    this.eventChoice = this.eventChoices[0].code;
  }

  fillBookingEvents(){
    this.eventChoices = null;
    this.eventChoices = [];
    this.eventChoices.push({"code": "C", "description": "Created"});
    this.eventChoices.push({"code": "R", "description": "Reroute"});
    this.eventChoice = this.eventChoices[0].code;
  }


  masterToggle(rowIn: NotificationView, selected:boolean) {
    if (selected){
      this.selection.deselect(rowIn);
    }else{
      this.selection.select(rowIn);
    }
  }

  checkAll(fromWhere: string){
    if (!this.allChecked){
      this.noneSelected = false;
      this.quickViewData.data.forEach(row => {this.selection.select(row)})
      this.allChecked = true;
    }else{
      this.quickViewData.data.forEach(row => {this.selection.deselect(row)})
      this.allChecked = false;
    }
  }

  resetScreen(){
    this.selection.clear()

    this.submitted = false;
    if (this.screenMode=="C"){
      this.classBackground = "newField";
      this.fillContainerEvents();
    }else{
      this.classBackground = "newField2";
      this.fillBookingEvents();
    }
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    this.quickViewData.filter = filterValue;
  }


  getSearchItems(){
    this.submitted = true;
    this.badChars = false;
    if (this.txtFromArea==undefined){
      this.didntEnterShit = true;
      return;
    }

    this.txtArray2 = [];

    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
    if (this.txtArray2.length==0){
      this.didntEnterShit = true;
      return;
    }
    this.didntEnterShit = false;
    var _i = this.txtArray2.length;
    while (_i--) {
      this.txtArray2[_i] = this.txtArray2[_i].valueOf().trim();
      if (!this.service.checkForSpecialChars(this.txtArray2[_i].valueOf())) {
        this.containerNum = this.txtArray2[_i].valueOf();
        this.badChars = true;
        return;
      }
      if (this.txtArray2[_i].valueOf() == "") {
        this.txtArray2.splice(_i, 1);
      }
    }
    this.txtArray2 = this.service.onlySendOneHundread(this.txtArray2);

    this.notificationArray = [];
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    for (var items of this.txtArray2){
      this.notification = {} as NotificationView;
      this.notification.entity_id = items.valueOf();
      this.notificationArray.push(this.notification);
    }
    this.clientRequest.requestData = this.notificationArray;
    var lhsUserObs$;
    if (this.screenMode=="C" && this.eventChoice=="F"){
      lhsUserObs$ = this.queryService.notificationSaveContainerReady(this.clientRequest);
    }else if (this.screenMode=="C" && this.eventChoice=="R"){
      lhsUserObs$ = this.queryService.notificationSaveContainerReceived(this.clientRequest);
    }else if (this.screenMode=="C" && this.eventChoice=="D"){
      lhsUserObs$ = this.queryService.notificationSaveContainerDelivered(this.clientRequest);
    }else if (this.screenMode=="B" && this.eventChoice=="C"){
      lhsUserObs$ = this.queryService.notificationSaveBooking(this.clientRequest);
    }else if (this.screenMode=="B" && this.eventChoice=="R"){
      lhsUserObs$ = this.queryService.notificationSaveBookingReroute(this.clientRequest);
    }

    this.subscription = lhsUserObs$.subscribe(
      (lhsUser) => {
        this.notificationArray = lhsUser;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.submitted = false;
        this.queryPending();
        if (this.ipadApp){
          this.ipadAppear = false;

        }
      });


  }

  public wipeOutSearch(){
    this.txtFromArea = null;
  }

  getNiceDate(dateIn: string): string {
    this.date1 = new Date(dateIn);
    return this.date1.toLocaleDateString("en-US", this.options4);
  }


  queryPending(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];

    this.clientRequest.requestData = this.notificationArray;
    var lhsUserObs$ = this.queryService.notificationGetPending(this.clientRequest);


    this.subscription = lhsUserObs$.subscribe(
      (lhsUser) => {
        this.notificationArray = lhsUser;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.selection.clear()

        this.formatRecords();
        this.notificationArrayDisplay = Object.assign([],this.notificationArray);
        this.querySent();

      });
  }

  formatRecords(){
    for (var items of this.notificationArray){
      if (items.entity=="UNIT"){
        items.entityDisp = "Container";
      }else{
        items.entityDisp = "Booking"
      }
      if (items.event.toUpperCase()=="UNIT_ENABLE_ROAD"){
        items.eventDisp = "Ready For Delivery";
      }else if (items.event.toUpperCase()=="UNIT_RECEIVE"){
        items.eventDisp = "Received"
      }else if (items.event.toUpperCase()=="UNIT_DELIVER"){
        items.eventDisp = "Delivered"
      }else if (items.event.toUpperCase()=="BOOKING_CREATE") {
        items.eventDisp = "Created"
      }else if (items.event.toUpperCase()=="REROUTE_BKG") {
        items.eventDisp = "Reroute"
      }
      if (items.notified!= null){
        items.status = "Sent";
      }else{
        items.status = "Pending"
      }


    }
  }

  querySent(){
    this.notificationArray =[];
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];

    this.clientRequest.requestData = this.notificationArray;
    var lhsUserObs$ = this.queryService.notificationGetSent(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lhsUser) => {
        this.notificationArray = lhsUser;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.selection.clear()

        this.formatRecords();
        this.notificationArrayDisplay = this.notificationArrayDisplay.concat(this.notificationArray);
        this.quickViewData = new MatTableDataSource<NotificationView>(this.notificationArrayDisplay);

      });
  }


  deleteRecords(){
    if (this.selection.selected.length==0){
      return;
    }

    this.notificationContainerArray =[];
    this.notificationBookingArray =[];
    for (var sel of this.selection.selected) {
      if (sel.entity=="UNIT"){
        this.notificationContainerArray.push(sel);
      }else{
        this.notificationBookingArray.push(sel);
      }
    }

    if (this.notificationContainerArray.length>0){
        this.deleteContainerRecords();
    }else if (this.notificationBookingArray.length>0){
      this.deleteBookingRecords();
    }




  }


  deleteContainerRecords(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.notificationContainerArray;

    var lhsUserObs$ = this.queryService.notificationDeleteContainerNotification(this.clientRequest);

    this.subscription = lhsUserObs$.subscribe(
      (lhsUser) => {
        this.notificationArray = lhsUser;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        if (this.notificationBookingArray.length>0){
          this.deleteBookingRecords();
        }else{
          this.queryPending();
        }
      });
  }

  deleteBookingRecords(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.notificationBookingArray;

    var lhsUserObs$ = this.queryService.notificationDeleteBookingNotification(this.clientRequest);

    this.subscription = lhsUserObs$.subscribe(
      (lhsUser) => {
        this.notificationArray = lhsUser;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {

          this.queryPending();

      });
  }




}
